import { tns } from 'tiny-slider/src/tiny-slider';

class StatsSlider {
	constructor(el, nav) {
		this.el = el;
		this.nav = nav;

		this.initSlider();
		this.handleResize = this.debounce(this.updateHeight.bind(this), 150);
		window.addEventListener('resize', this.handleResize);
		this.updateHeight();
	}

	initSlider() {
		this.slider = tns({
			container: this.el,
			items: 1,
			slideBy: 1,
			mode: "gallery",
			autoplay: true,
			autoplayButtonOutput: false,
			speed: 400,
			controls: false,
			nav: true,
			navPosition: "bottom",
			navContainer: this.nav
		});
	}


	updateHeight() {
		if (!this.el) return;

		let maxHeight = 0;
		const slides = this.el.querySelectorAll('.stats__stat-slide');

		slides.forEach(slide => {
			slide.style.height = 'auto'; // reset height
			maxHeight = Math.max(maxHeight, slide.offsetHeight);
		});

		this.el.style.height = `${maxHeight}px`;
	}


	debounce(func, wait) {
		let timeout;
		return (...args) => {
			clearTimeout(timeout);
			timeout = setTimeout(() => func.apply(this, args), wait);
		};
	}
}

export default StatsSlider;